import React from 'react';
import { Link } from 'react-router-dom';
import './index.css';

const LifestyleSection = () => {
  return (
    <div className="hs-section">
      <div className="hs-text">
        <p className="hs-label">Lifestyle Investments</p>
        <h1 className="hs-title">Curated Property Opportunities</h1>
        <p className="hs-desc">Curated opportunities in holiday homes, riverside retreats, managed villas and experiential real estate.</p>
        <Link to='/lifestyle-investments'><button className="hs-btn">Explore Opportunities</button></Link>
      </div>
      <div className="hs-image">
        <img
          src="https://firebasestorage.googleapis.com/v0/b/phone-auth-d0a8d.appspot.com/o/Luxeunbounded%2FLU%20Amaya%20website%20image%202.jpg?alt=media&token=237fe6ea-788a-4359-ae0f-3b5cfe953c8e"
          alt="Lifestyle Investments"
        />
      </div>
    </div>
  );
};

export default LifestyleSection;
